// Pixel initialization and event firing.
// Pixels only load when REACT_APP_PIXELS_ENABLED=true is set at build time.
// Pixel IDs: REACT_APP_META_PIXEL_ID, REACT_APP_TIKTOK_PIXEL_ID, REACT_APP_GTAG_ID

const ENABLED = process.env.REACT_APP_PIXELS_ENABLED === 'true';
const META_ID  = process.env.REACT_APP_META_PIXEL_ID;
const TIKTOK_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;
const GTAG_ID  = process.env.REACT_APP_GTAG_ID;

function injectScript(src) {
  if (document.querySelector(`script[src="${src}"]`)) return;
  const s = document.createElement('script');
  s.src = src;
  s.async = true;
  document.head.appendChild(s);
}

export function initPixels() {
  if (!ENABLED) return;

  // Meta Pixel
  if (META_ID) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', META_ID);
    window.fbq('track', 'PageView');
  }

  // TikTok Pixel
  if (TIKTOK_ID) {
    /* eslint-disable */
    !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load(TIKTOK_ID);ttq.page();}(window,document,'ttq');
    /* eslint-enable */
  }

  // Google Tag
  if (GTAG_ID) {
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GTAG_ID);
  }
}

// event: 'ViewContent' | 'Lead' | 'InitiateCheckout' | 'Purchase' | 'CompleteRegistration'
export function firePixelEvent(event, data = {}) {
  if (!ENABLED) return;
  try {
    if (META_ID && window.fbq) window.fbq('track', event, data);
    // TikTok event name mapping
    const ttMap = {
      ViewContent: 'ViewContent',
      Lead: 'CompleteRegistration',
      InitiateCheckout: 'InitiateCheckout',
      Purchase: 'PlaceAnOrder',
      CompleteRegistration: 'CompleteRegistration',
    };
    if (TIKTOK_ID && window.ttq && ttMap[event]) window.ttq.track(ttMap[event], data);
    // Google Ads conversion
    if (GTAG_ID && window.gtag && (event === 'Lead' || event === 'Purchase')) {
      window.gtag('event', 'conversion', { send_to: GTAG_ID, ...data });
    }
  } catch {}
}
